import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getAuditTrailByid } from '../../../../redux/auditTrailSlice'
import { SortTableData } from '../../../../common/AppTable/SortTableData'
import AppBar from '../../../../common/AppBar'
import ModuleForm from '../../../../pages/AddModule/ModuleForm'
import Loader from '../../../../common/Loader'
import TableOfDocuments from '../../../../pages/AddModule/TableOfDocuments'
import RenderHtml from '../../../../common/AppSpecificConpnents/PartsTable/RenderHtml'
import { TableActionGroup } from '../../../../common/Buttons'

import { useS3Data } from '../../../../hooks/useS3Data'

const ModulePreview = () => {
  const { audit_trail_id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [auditData, setAuditData] = useState(null)
  const { loading: auditLoading } = useSelector(state => state.audittrail)
  const { unlinkModules, unlkmdlPagination } = useSelector((state) => state.module)

  useEffect(() => {
    (async () => {
      try {
        const resp = await dispatch(getAuditTrailByid({ id: audit_trail_id }))
        setAuditData(resp.payload.results)
      } catch (error) {
        console.error('Error fetching audit trail:', error)
      }
    })()
  }, [dispatch, audit_trail_id])

  const { data: s3Data, loading: s3Loading } = useS3Data(auditData?.new_content_snapshot)

  const moduleData = s3Data || auditData?.version_content || {}
  const isUnlink = moduleData?.isUnlink || false
  const tableRows = moduleData?.tableOfDocuments || []

  const isLoading = auditLoading || s3Loading

  // Get module title
  const moduleTitle = moduleData?.pageTitle || ""
  return (
    <div>
      <AppBar
        title={moduleTitle}
        showBlackTitle={true}
        onBack={() => navigate(-1)}
        showTablesDropdown={false}
        showProfileButton={false}
      />
      
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <ModuleForm
            selectedProject={moduleData?.selectedProject}
            procedureNumber={moduleData?.procedureNumber}
            flowChartProcedureNumber={moduleData?.flowChartProcedureNumber}
            description={moduleData?.description}
            formShortDescription={moduleData?.short_description}
            previewUrl={auditData?.version_content.product_image}
            showUploadAsFallback={auditData?.version_content.product_image ? false : true} 
            isUnlink={isUnlink}
            disabled={true}
            allowSave={false}
            moduleData={true}
            // Popup handlers are not needed in disabled mode, but provide empty functions to avoid errors
            onOpenProjectPopup={() => {}}
            onOpenItemCodePopup={() => {}}
            onOpenFlowchartPopup={() => {}}
            onClearProject={() => {}}
            onClearItemCode={() => {}}
            onClearFlowchart={() => {}}
            onImageUpload={() => {}}
            onDeleteImage={() => {}}
            onShortDescriptionChange={() => {}}
            usingInAuditTrail={true}
          />
          
          {/* Table of Documents (search/filter disabled for audit trail preview) */}
          <TableOfDocuments
            moduleData={moduleData}
            unlinkModules={unlinkModules}
            isUnlink={isUnlink}
            disableSearch={true}
            columns={[
              {
                headName: "Item Code",
                field: "partNumber",
                required: true,
              },
              { headName: "Type", field: "type" },
              {
                headName: "Description",
                field: "description",
              },
              { headName: "Action", field: "Action", textCenter: true },
            ]}
            pagination={{
              pagination: unlkmdlPagination,
              paginationPosition: {
                position: "center",
              },
              showRecentItems: isUnlink,
            }}
          >
            {tableRows.map((row, index) => (
              <tr key={index}>
                <td>{row.partNumber || ""}</td>
                <td>{row.type || ""}</td>
                <td>
                  <RenderHtml content={row.description || ""} />
                </td>
                <td>
                  <TableActionGroup
                    mode="view"
                    showEdit={true}
                    showDelete={true}
                    showSelect={true}
                    disableEdit={true}
                    disableDelete={true}
                    disableSelect={true}
                  />
                </td>
              </tr>
            ))}
          </TableOfDocuments>
          <br />
        </>
      )}
    </div>
  )
}

export default ModulePreview


